import { useQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { GetRegisterByIdResponse } from 'api';

export const COMMON_REGISTER_QUERY_KEY = 'vestra-sr/common-single-register';

export const useRegisterQuery = (id: number, disabled = false) => {
  return useQuery<GetRegisterByIdResponse>({
    queryKey: [COMMON_REGISTER_QUERY_KEY, id],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response = await api.v1.getRegisterByIdV1SrRegistersIdGet({ id });
      return response.data;
    },
    keepPreviousData: true,
    retry: 2,
    enabled: !disabled,
  });
};
